import { ServiceContractWithProducts } from "../../../../models";
import { CustomerServiceContractsDTO } from "../dtos";

export const mapCustomerServiceContractsDTOtoCustomerServiceContracts = (
  customerServiceContractsApiDTO: CustomerServiceContractsDTO["data"]
): ServiceContractWithProducts[] => {
  return customerServiceContractsApiDTO.serviceContracts.map((serviceContractDTO) => {
    return {
      id: serviceContractDTO.id,
      licenses: serviceContractDTO.licenses.map((license) => ({
        id: license.id,
        name: license.name,
        qty: license.qty,
        activo: license.activo,
        family: license.family ?? "",
        productId: license.productId ?? "",
        product: license.product
          ? {
              _id: license.product._id,
              name: license.product.name,
              family: license.product.family,
              hubspotId: license.product.hubspotId,
              activations: license.product.activations,
            }
          : undefined,
      })),
    };
  });
};
